import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Module } from '../../../services/module.service';

@Component({
    selector: 'app-delete-module-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './delete-module-dialog.component.html',
    styleUrl: './delete-module-dialog.component.scss'
})
export class DeleteModuleDialogComponent {
    constructor(
        // eslint-disable-next-line no-unused-vars
        public dialogRef: MatDialogRef<DeleteModuleDialogComponent>,
        // eslint-disable-next-line no-unused-vars
        @Inject(MAT_DIALOG_DATA) public data: { module: Module }
    ) {}

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }
}

